import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions';
import queryString from 'query-string';
import { setAccessToken } from '../utils/AuthService';

class User extends Component{

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    if(params){
      setAccessToken(params.token, params.refresh);
      this.props.actions.setTokens(params.token, params.refresh);
      this.props.actions.getMyInfo()
      .then(() => {
        this.props.history.push('/playlists');
      });
      
    }
    this.props.actions.getMyInfo();
  }

  render() {
    return (
      <div>
        <h2>logged in!</h2>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps){
  return {
    currentUser: state.currentUser,
    accessToken: state.accessToken
  };
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(actions, dispatch)
    // echoToken: token => dispatch(actions.echoToken(token)),
    // setTokens: (accessToken, refreshToken) => dispatch(actions.setTokens({accessToken, refreshToken}))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(User);


// WEBPACK FOOTER //
// ./src/components/User.js